import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseComponent } from "../BaseComponent";
import { UserModel } from "../../models/UserModel";
import { ServiceChangesService } from "../service-changes/service/service-changes.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/internal/operators/takeUntil";
import { ProviderDefault } from "src/models/ProviderDefault";

@Component({
  selector: "app-homepage",
  templateUrl: "./homepage.component.html",
  styleUrls: ["./homepage.component.scss"],
})
export class HomepageComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  user: UserModel;
  role: string;
  urlReportBI: string = "";
  providerDefaultSelected: ProviderDefault = {
    cod: "DXC",
    dateInsert: 0,
    dateUpdate: 0,
    deleteDate: 0,
    deleted: 0,
    description: "",
    firstMonth: "",
    id: 0,
    idUserInsert: 0,
    idUserUpdate: 0,
    inContTypeSett: "",
    lastConsolidatedMonth: "",
    lastMonth: "",
    lastUploadedBilling: "",
    lastUploadedCharging: "",
    lastUploadedKynBandwidth: "",
    lastUploadedVolume: "",
  };
  displayedColumns = ["position", "name", "weight", "symbol"];
  providerCod: string = "";
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    route: ActivatedRoute,
    router: Router,
    private serviceChangesService: ServiceChangesService
  ) {
    super(route, router);
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.role = this.user.roleList[0].toLowerCase();
  }

  ngOnInit() {
    this.serviceChangesService.providerDefault$.pipe(takeUntil(this.destroy$)).subscribe({
      next: res =>{
        if(res){
          this.providerDefaultSelected = res;
          this.providerCod = res.cod;

          if(this.providerCod.includes("KYN")){
            this.urlReportBI = "https://app.powerbi.com/links/HKnQMDbYQm?ctid=d852d5cd-724c-4128-8812-ffa5db3f8507&pbi_source=linkShare";
          }
          else {
            this.urlReportBI = "https://app.powerbi.com/links/z6wyQ6YAyb?ctid=d852d5cd-724c-4128-8812-ffa5db3f8507&pbi_source=linkShare";
          }
        }
      }
    })

    this.serviceChangesService.providerFilterValue$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res && res.cod) {
            this.providerCod = res.cod;

            if(this.providerCod.includes("KYN")){
              this.urlReportBI = "https://app.powerbi.com/links/HKnQMDbYQm?ctid=d852d5cd-724c-4128-8812-ffa5db3f8507&pbi_source=linkShare";
            }
            else {
              this.urlReportBI = "https://app.powerbi.com/links/z6wyQ6YAyb?ctid=d852d5cd-724c-4128-8812-ffa5db3f8507&pbi_source=linkShare";
            }
          }
        },
      });
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  onFileComplete($event: string) {}
}
